// App.jsx (no BrowserRouter here)
import { Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import LoginForm from './LoginForm';
import RegisterStore from './RegisterStore';
import Dashboard from './Dashboard';
import PosRunner from './PosRunner';

function RequireAuth() {
  const location = useLocation();
  const user = localStorage.getItem('user');
  const sid = Number(localStorage.getItem('store_id') || 0);
  if (!user || !sid) return <Navigate to="/login" replace state={{ from: location }} />;
  return <Outlet />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<LoginForm />} />
      <Route path="/register-store" element={<RegisterStore />} />
      <Route path="/register" element={<Navigate to="/register-store" replace />} />
      <Route element={<RequireAuth />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/pos" element={<PosRunner />} />
      </Route>
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
